import { childrenOf, toPlainText } from '@orbit-mind/domain';
import { outlineOf } from './outline';
export const EXPORT_FORMATS = [
    { id: 'png', label: 'PNG' },
    { id: 'jpg', label: 'JPEG' },
    { id: 'svg', label: 'SVG' },
    { id: 'pdf', label: 'PDF · Mapa' },
    { id: 'report', label: 'PDF · Relatório' },
    { id: 'md', label: 'Markdown' },
    { id: 'txt', label: 'TXT' },
    { id: 'json', label: 'Orbit Mind · JSON' },
    { id: 'mm', label: 'FreeMind · .mm' },
];
export function renderText(document) {
    return outlineOf(document)
        .map((item) => `${'  '.repeat(item.depth)}${item.text}${item.notes ? `\n${'  '.repeat(item.depth + 1)}${item.notes.replace(/\n/g, '\n' + '  '.repeat(item.depth + 1))}` : ''}`)
        .join('\n');
}
function xml(value) {
    // XML 1.0 excludes these control codes.
    return (value
        // eslint-disable-next-line no-control-regex
        .replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f]/g, '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;'));
}
/** Hierarchy and notes, independent of the visual layout. No executable or external XML content. */
export function renderFreemind(document) {
    const visit = (node) => {
        const notes = node.notes === undefined ? '' : toPlainText(node.notes);
        return `<node ID="${xml(node.id)}" TEXT="${xml(node.plainText)}">${notes ? `<richcontent TYPE="NOTE"><html><head/><body><p>${xml(notes).replace(/\n/g, '<br/>')}</p></body></html></richcontent>` : ''}${childrenOf(document, node.id).map(visit).join('')}</node>`;
    };
    const root = document.nodes[document.map.rootNodeId];
    return `<?xml version="1.0" encoding="UTF-8"?><map version="1.0.1">${root === undefined ? '' : visit(root)}</map>`;
}
/** Native editable document. Attachment references are included; binary files are separate. */
export function renderNativeJson(document) {
    return JSON.stringify(document, null, 2);
}
//# sourceMappingURL=portable.js.map